import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireQuizUserAttempt} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class QuizUserAttemptService implements CrudService<UmpireQuizUserAttempt> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireQuizUserAttempt[]>> {
    return this.http
      .get('/quiz_user_attempts', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    id: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizUserAttempt>> {
    return this.http
      .get(`/quiz_user_attempts/${id}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/quiz_user_attempts/${id}`);
  }

  update(
    body: Partial<UmpireQuizUserAttempt>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizUserAttempt>> {
    return this.http
      .patch<JsonApiResponse<UmpireQuizUserAttempt>>(
        `/quiz_user_attempts/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
